import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import IpadNavigation from 'Navigation/IpadNavigation'
import More from 'More/views/MoreView/containers/Smartphones'
import { CapcitoCollaboration } from 'MarketPlace/Capcito/views/CapcitoCollaborationView/containers/Smartphones'

class CapcitoCollaborationView extends Component {
  static propTypes = {
    t: PropTypes.func,
    location: PropTypes.object.isRequired
  }

  render () {
    const { t, location } = this.props
    const navBarTitle = t('capcitoCollaboration', 'title').s

    return (
      <IpadNavigation title={navBarTitle} location={location} withoutMaxWidth>
        <More notRightIcon isIpad />
        <CapcitoCollaboration
          {...this.collaborationConfig}
          {...this.props}
        />
      </IpadNavigation>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    t: state.i18n.get('app', 'views', 'MarketPlace')
  }
}

export default connect(mapStateToProps)(CapcitoCollaborationView)
